import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import { Box, Button, FormControl } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../../components/chip/chipCmp";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import Autocomplate from "../../../components/dropdown/Autocomplate";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetEnumsResponse } from "../../../models/enum.model";
import { SettlmentRequestHistoryFilter } from "../../../models/settlement.model";
import { convertDate } from "../../../utility/convertDate";
import { commaSeprator } from "../../../utility/commaSeprator";
import { commaSeparatedToNum } from "../../../utility/commaSepratedToNum";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface Props {
  setFilterObject: (filterObj: SettlmentRequestHistoryFilter) => void;
  settlementTypes: GetEnumsResponse[];
  setCurrentPaginationInfo: (page: any) => void;
}
const SettlmentHistoryFilter = ({
  setFilterObject,
  settlementTypes,
  setCurrentPaginationInfo,
}: Props) => {
  const [formData, setFormData] = useState<SettlmentRequestHistoryFilter>();
  const [createDateFrom, setCreateDateFrom] = useState<
    Date[] | null | undefined
  >(null);
  const [confirmDatePersian, setConfirmDatePersian] = useState<
    Date[] | null | undefined
  >(null);
  const [valueCreateDateFrom, setValueCreateDateFrom] = useState<string>();
  const [valueConfirmDatePersian, setValueConfirmDatePersian] = useState<
    string
  >();
  const [valueSettlementTypes, setValueSettlementTypes] = useState<any[]>([]);

  const [
    valueSettlementTypesOptions,
    setValueSettlementTypesOptions,
  ] = useState<number[]>([]);

  const queryClient = useQueryClient();

  function changeCreateDate(e: any) {
    setValueCreateDateFrom(e.toString().replace(/,/g, " - "));
    setCreateDateFrom(e);
  }
  function changeConfirmDatePersian(e: any) {
    setValueConfirmDatePersian(e.toString().replace(/,/g, " - "));
    setConfirmDatePersian(e);
  }
  function changeValueSettlementTypesOptions(e: any, value: any) {
    setValueSettlementTypesOptions([...value]);
    setValueSettlementTypes([...e]);
  }

  const setChildCreatorName = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, creatorName: undefined };
    setFormData({ ...formData, creatorName: "" });
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSayadNumber = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, sayadNumber: undefined };
    setFormData({ ...formData, sayadNumber: "" });
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildChequeSeri = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, chequeSeri: "" });
    tableFilter = { ...tableFilter!, chequeSeri: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildChequeSerial = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, chequeSerial: "" });
    tableFilter = { ...tableFilter!, chequeSerial: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildTransactionNumber = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, transactionNumber: "" });
    tableFilter = { ...tableFilter!, transactionNumber: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, factorAmountFrom: null });
    tableFilter = { ...tableFilter!, factorAmountFrom: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildFactorAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, factorAmountTo: null });
    tableFilter = { ...tableFilter!, factorAmountTo: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountFrom = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, settlementAmountFrom: null });
    tableFilter = { ...tableFilter!, settlementAmountFrom: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSettlementAmountTo = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    setFormData({ ...formData, settlementAmountTo: null });
    tableFilter = { ...tableFilter!, settlementAmountTo: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildSaleDate = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, createDateFrom: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setValueCreateDateFrom(undefined);
    setCreateDateFrom(undefined);
    setFilterObject(tableFilter!);
  };
  const setChildConfirmDate = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, confirmDateFrom: undefined };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter!
    );
    setValueConfirmDatePersian(undefined);
    setConfirmDatePersian(undefined);
    setFilterObject(tableFilter!);
  };

  const handleChangeForm = (event: any) => {
    const includeIds = [
      "factorAmountFrom",
      "factorAmountTo",
      "settlementAmountFrom",
      "settlementAmountTo",
    ];

    setFormData({
      ...formData!,
      [event.target.id]: includeIds.includes(event.target.id)
        ? event.target.value.replace(/,/g, "")
        : event.target.value,
    });
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      {
        ...formData!,
        [event.target.id]: includeIds.includes(event.target.id)
          ? event.target.value.replace(/,/g, "")
          : event.target.value,
      }
    );
  };
  const setChildBranch = (chip: any) => {
    const selectedItem = valueSettlementTypes.filter(
      (item: any) => item !== chip
    );
    setValueSettlementTypes(selectedItem);
    const tabelFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.settlementType = tabelFilter!.settlementType
        ?.filter((item: any) => item !== chip)
        .map((items: any) => {
          return items;
        });
    }
    setFilterObject(tabelFilter!);
  };

  const deleteChip = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    tableFilter = { ...tableFilter!, settlementType: [] };
    tableFilter.chequeSeri = "";
    tableFilter.chequeSerial = "";
    tableFilter.confirmerName = "";
    tableFilter.creatorName = "";
    tableFilter.factorAmountFrom = null;
    tableFilter.factorAmountTo = null;
    tableFilter.settlementAmountFrom = null;
    tableFilter.settlementAmountTo = null;
    tableFilter.sayadNumber = "";
    tableFilter.transactionNumber = "";
    setValueSettlementTypes([]);
    setValueSettlementTypesOptions([]);
    setCreateDateFrom(null);
    setConfirmDatePersian(null);
    setValueConfirmDatePersian(undefined);
    setValueCreateDateFrom(undefined);
    setFormData({
      ...formData,
      creatorName: "",
      chequeSeri: "",
      chequeSerial: "",
      confirmerName: "",
      factorAmountFrom: null,
      factorAmountTo: null,
      settlementAmountFrom: null,
      settlementAmountTo: null,
      sayadNumber: "",
      transactionNumber: "",
    });
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter
    );
    setFilterObject({});
  };

  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter"
    );
    const convertedCreateDate = convertDate(createDateFrom);
    const convertedConfirmDate = convertDate(confirmDatePersian);
    tableFilter = {
      ...tableFilter!,
      createDateFrom: Array.isArray(convertedCreateDate)
        ? convertedCreateDate[0]
        : convertedCreateDate,
      createDateTo: Array.isArray(convertedCreateDate)
        ? convertedCreateDate[1]
        : undefined,
      confirmDateFrom: Array.isArray(convertedConfirmDate)
        ? convertedConfirmDate[0]
        : convertedConfirmDate,
      confirmDateTo: Array.isArray(convertedConfirmDate)
        ? convertedConfirmDate[1]
        : undefined,
      settlementType: valueSettlementTypes,
    };
    queryClient.setQueryData<SettlmentRequestHistoryFilter>(
      "SettlementHistoryFilter",
      tableFilter
    );
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });

    setFilterObject(tableFilter);
  };

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <div className='row'>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container'
            style={{ marginTop: "1vh" }}
          >
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                {settlementTypes && (
                  <div dir='rtl'>
                    <AutocomplateCheckbox
                      id='settlementTypes'
                      name='settlementTypes'
                      value={valueSettlementTypesOptions}
                      label={"نوع تسویه"}
                      options={settlementTypes}
                      onChange={changeValueSettlementTypesOptions}
                      changeMultiSelect={changeValueSettlementTypesOptions}
                      responseValue={valueSettlementTypes}
                    />
                  </div>
                )}
              </ThemeProvider>
            </CacheProvider>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"ثبت کننده"}
              label={"ثبت کننده"}
              required={false}
              value={formData?.creatorName}
              onChange={(e: any) => handleChangeForm(e)}
              name='creatorName'
              id='creatorName'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <FormControl fullWidth className='shadowDatepicker'>
              <DatePickerComponents
                valueArray={createDateFrom}
                label={"تاریخ ثبت"}
                onChange={changeCreateDate}
                range={true}
              />
            </FormControl>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <FormControl fullWidth className='shadowDatepicker'>
              <DatePickerComponents
                valueArray={confirmDatePersian}
                label={"تاریخ تایید"}
                onChange={changeConfirmDatePersian}
                range={true}
              />
            </FormControl>
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ فاکتور از (ریال)"}
              label={"مبلغ فاکتور از (ریال)"}
              required={false}
              value={
                formData?.factorAmountFrom
                  ? commaSeprator(formData?.factorAmountFrom)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='factorAmountFrom'
              id='factorAmountFrom'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ فاکتور تا (ریال)"}
              label={"مبلغ فاکتور تا (ریال)"}
              required={false}
              value={
                formData?.factorAmountTo
                  ? commaSeprator(formData?.factorAmountTo)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='factorAmountTo'
              id='factorAmountTo'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ تسویه از (ریال)"}
              label={"مبلغ تسویه از (ریال)"}
              required={false}
              value={
                formData?.settlementAmountFrom
                  ? commaSeprator(formData?.settlementAmountFrom)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='settlementAmountFrom'
              id='settlementAmountFrom'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"مبلغ تسویه تا (ریال)"}
              label={"مبلغ تسویه تا (ریال)"}
              required={false}
              value={
                formData?.settlementAmountTo
                  ? commaSeprator(formData?.settlementAmountTo)
                  : ""
              }
              onChange={(e: any) => handleChangeForm(e)}
              name='settlementAmountTo'
              id='settlementAmountTo'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره صیادی"}
              label={"شماره صیادی"}
              required={false}
              value={formData?.sayadNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name='sayadNumber'
              id='sayadNumber'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"سری چک"}
              label={"سری چک"}
              required={false}
              value={formData?.chequeSeri}
              onChange={(e: any) => handleChangeForm(e)}
              name='chequeSeri'
              id='chequeSeri'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"سریال چک"}
              label={"سریال چک"}
              required={false}
              value={formData?.chequeSerial}
              onChange={(e: any) => handleChangeForm(e)}
              name='chequeSerial'
              id='chequeSerial'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره تراکنش آنلاین"}
              label={"شماره تراکنش آنلاین"}
              required={false}
              value={formData?.transactionNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name='transactionNumber'
              id='transactionNumber'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant='contained'
              // type="submit"
              className='btnForm SuccessDefault  '
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>
        {(formData?.factorAmountTo! > 0 ||
          formData?.creatorName ||
          formData?.factorAmountFrom! > 0 ||
          formData?.chequeSeri ||
          formData?.chequeSerial ||
          formData?.confirmerName ||
          formData?.sayadNumber ||
          formData?.settlementAmountFrom! > 0 ||
          formData?.settlementAmountTo! > 0 ||
          formData?.transactionNumber ||
          confirmDatePersian ||
          valueSettlementTypes?.length ||
          createDateFrom) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className='row tableCMP'
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src='images/RemoveAllFilters.svg'
                alt=''
              />
            </Button>
            <ChipCmp
              item={formData?.creatorName}
              enamValue={formData?.creatorName}
              index={formData?.creatorName?.length}
              setChildValue={setChildCreatorName}
            />
            <ChipCmp
              item={valueSettlementTypes}
              enamValue={settlementTypes}
              index={valueSettlementTypes?.length}
              setChildValue={setChildBranch}
            />
            <ChipCmp
              item={formData?.factorAmountFrom}
              enamValue={commaSeparatedToNum(formData?.factorAmountFrom)}
              index={String(formData?.factorAmountFrom)?.length}
              setChildValue={setChildFactorAmountFrom}
            />
            <ChipCmp
              item={formData?.factorAmountTo}
              enamValue={commaSeparatedToNum(formData?.factorAmountTo)}
              index={String(formData?.factorAmountTo)?.length}
              setChildValue={setChildFactorAmountTo}
            />
            <ChipCmp
              item={formData?.settlementAmountFrom}
              enamValue={commaSeparatedToNum(formData?.settlementAmountFrom)}
              index={String(formData?.settlementAmountFrom)?.length}
              setChildValue={setChildSettlementAmountFrom}
            />
            <ChipCmp
              item={formData?.settlementAmountTo}
              enamValue={commaSeparatedToNum(formData?.settlementAmountTo)}
              index={String(formData?.settlementAmountTo)?.length}
              setChildValue={setChildSettlementAmountTo}
            />
            <ChipCmp
              item={valueCreateDateFrom}
              enamValue={valueCreateDateFrom}
              index={valueCreateDateFrom?.length}
              setChildValue={setChildSaleDate}
            />
            <ChipCmp
              item={valueConfirmDatePersian}
              enamValue={valueConfirmDatePersian}
              index={valueConfirmDatePersian?.length}
              setChildValue={setChildConfirmDate}
            />
            <ChipCmp
              item={formData?.confirmerName}
              enamValue={formData?.confirmerName}
              index={formData?.confirmerName?.length}
              setChildValue={setChildSayadNumber}
            />
            <ChipCmp
              item={formData?.sayadNumber}
              enamValue={formData?.sayadNumber}
              index={formData?.sayadNumber?.length}
              setChildValue={setChildSayadNumber}
            />
            <ChipCmp
              item={formData?.chequeSeri}
              enamValue={formData?.chequeSeri}
              index={formData?.chequeSeri?.length}
              setChildValue={setChildChequeSeri}
            />
            <ChipCmp
              item={formData?.chequeSerial}
              enamValue={formData?.chequeSerial}
              index={formData?.chequeSerial?.length}
              setChildValue={setChildChequeSerial}
            />
            <ChipCmp
              item={formData?.transactionNumber}
              enamValue={formData?.transactionNumber}
              index={formData?.transactionNumber?.length}
              setChildValue={setChildTransactionNumber}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default SettlmentHistoryFilter;
